// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* StarfieldBackground.css - Contains all styles for the starfield animation */

/**
 * This file contains styles specific to the starfield animation.
 * It uses CSS variables from the theme system for consistency.
 */

/* Main container for the starfield */
.starfield-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: transparent; /* Default background */
  z-index: var(--z-index-starfield); /* Use z-index from theme system */
  perspective: 500px;
  perspective-origin: 50% 50%;
  transition: all 0.5s ease;
  pointer-events: none; /* Allow clicks to pass through */
}

/* Cyberpunk theme specific styles */
.starfield-container.cyberpunk {
  background-color: rgba(5, 5, 32, 0.8);
  perspective: 300px;
}

/* Star animations */
@keyframes starfieldMove {
  from { 
    transform: translateZ(0px); 
    opacity: 0;
  }
  10% {
    opacity: 0.8;
  }
  90% {
    opacity: 0.8;
  }
  to { 
    transform: translateZ(1000px); 
    opacity: 0;
  }
}

/* Warp streaks animation */
@keyframes warpEffect {
  from { 
    transform: translateZ(0px) scaleX(1); 
    opacity: 0;
  }
  5% {
    opacity: 1;
  }
  95% {
    opacity: 1;
  }
  to { 
    transform: translateZ(1000px) scaleX(3); 
    opacity: 0;
  }
}

/* Canvas element styling - direct targeting for the starfield canvas */
#space-travel-effect {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: var(--z-index-starfield) !important;
  pointer-events: none !important;
  background-color: var(--color-black) !important;
  opacity: 0;
  transition: opacity 0.5s ease;
}

/* Visible state for the canvas */
#space-travel-effect.visible {
  opacity: 1 !important;
}

/* Star styling */
.star {
  position: absolute;
  background-color: white;
  border-radius: 50%;
  animation-name: starfieldMove;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  box-shadow: 0 0 1px white;
  z-index: 1; /* Increase visibility */
}

/* Warp streak styling */
.warp-streak {
  position: absolute;
  background-color: white;
  border-radius: 0;
  animation-name: warpEffect;
  animation-timing-function: cubic-bezier(0.1, 0, 0.9, 1);
  animation-iteration-count: infinite;
  z-index: 2; /* Increase visibility */
}
`, "",{"version":3,"sources":["webpack://./src/components/background/StarfieldBackground.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E;;;EAGE;;AAEF,qCAAqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,6BAA6B,EAAE,uBAAuB;EACtD,iCAAiC,EAAE,kCAAkC;EACrE,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB,EAAE,iCAAiC;AACzD;;AAEA,oCAAoC;AACpC;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,6BAA6B;IAC7B,UAAU;EACZ;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,oCAAoC;IACpC,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,uCAAuC;IACvC,UAAU;EACZ;AACF;;AAEA,uEAAuE;AACvE;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,4CAA4C;EAC5C,+BAA+B;EAC/B,+CAA+C;EAC/C,UAAU;EACV,6BAA6B;AAC/B;;AAEA,iCAAiC;AACjC;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;EACjC,mCAAmC;EACnC,yBAAyB;EACzB,UAAU,EAAE,wBAAwB;AACtC;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;EAC1B,uDAAuD;EACvD,mCAAmC;EACnC,UAAU,EAAE,wBAAwB;AACtC","sourcesContent":["/* StarfieldBackground.css - Contains all styles for the starfield animation */\n\n/**\n * This file contains styles specific to the starfield animation.\n * It uses CSS variables from the theme system for consistency.\n */\n\n/* Main container for the starfield */\n.starfield-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background-color: transparent; /* Default background */\n  z-index: var(--z-index-starfield); /* Use z-index from theme system */\n  perspective: 500px;\n  perspective-origin: 50% 50%;\n  transition: all 0.5s ease;\n  pointer-events: none; /* Allow clicks to pass through */\n}\n\n/* Cyberpunk theme specific styles */\n.starfield-container.cyberpunk {\n  background-color: rgba(5, 5, 32, 0.8);\n  perspective: 300px;\n}\n\n/* Star animations */\n@keyframes starfieldMove {\n  from { \n    transform: translateZ(0px); \n    opacity: 0;\n  }\n  10% {\n    opacity: 0.8;\n  }\n  90% {\n    opacity: 0.8;\n  }\n  to { \n    transform: translateZ(1000px); \n    opacity: 0;\n  }\n}\n\n/* Warp streaks animation */\n@keyframes warpEffect {\n  from { \n    transform: translateZ(0px) scaleX(1); \n    opacity: 0;\n  }\n  5% {\n    opacity: 1;\n  }\n  95% {\n    opacity: 1;\n  }\n  to { \n    transform: translateZ(1000px) scaleX(3); \n    opacity: 0;\n  }\n}\n\n/* Canvas element styling - direct targeting for the starfield canvas */\n#space-travel-effect {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  z-index: var(--z-index-starfield) !important;\n  pointer-events: none !important;\n  background-color: var(--color-black) !important;\n  opacity: 0;\n  transition: opacity 0.5s ease;\n}\n\n/* Visible state for the canvas */\n#space-travel-effect.visible {\n  opacity: 1 !important;\n}\n\n/* Star styling */\n.star {\n  position: absolute;\n  background-color: white;\n  border-radius: 50%;\n  animation-name: starfieldMove;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n  box-shadow: 0 0 1px white;\n  z-index: 1; /* Increase visibility */\n}\n\n/* Warp streak styling */\n.warp-streak {\n  position: absolute;\n  background-color: white;\n  border-radius: 0;\n  animation-name: warpEffect;\n  animation-timing-function: cubic-bezier(0.1, 0, 0.9, 1);\n  animation-iteration-count: infinite;\n  z-index: 2; /* Increase visibility */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
